// extracted by mini-css-extract-plugin
export default {"container":"yB-z","dimension":"zB-z","dimensionLabels":"AB-z"};